
import { defineComponent } from "vue";
import validators from "@/utils/validators";

type ComponentData = {
  text?: string;
  validation_message?: string;
};

export default defineComponent({
  name: "PasswordField",
  data(): ComponentData {
    return { text: "", validation_message: undefined };
  },
  methods: {
    validate() {
      this.validation_message = undefined;
      const vals = { required: {}, password: {} } as {[validator: string]: any};

      if (!this.required) {
        delete vals["required"]
        if(this.text?.length == 0 || this.text == undefined){
          this.text = undefined;
          this.$emit("updateValidation", this.name, true);
          return;
        }
      }

      for (let name in vals) {
        const message = validators[name](this.text, validators[name]);
        if (message) {
          this.$emit("updateValidation", this.$props.name, false);
          return (this.validation_message = message as string);
        }
      }
      this.$emit("updateValidation", this.name, true);
    },
  },
  props: {
    modelValue: String,
    name: String,
    label: String,
    manual_focus: Boolean,
    format: String,
    validation: Object,
    required: Boolean,
  },
  emits: ["update:modelValue", "updateValidation"],
  watch: {
    text(n) {
      this.$emit("update:modelValue", n);
    },
    validation(value) {
      this.validation_message = value.message;
    },
  },
});
